import React, { useState, useEffect } from "react" ;

import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { getChildResources } from "root/DataFunctions/ChildDataFns";

import ResourceCard from "../Components/UI/ResourceCard";
import Loading from "../Components/Loading";

const Feelings = () => {
    const [feelings, setFeelings] = useState("");
    
    useEffect(() => {
        getChildResources(5, (response) =>
        {
            setFeelings(getDataFromResponse(response));
        });
    }, []);

    return (
        <div style={{flex: "1"}}>
            <div className="child_breadcrumb child_breadcrumb-main">
                <div className="child_breadcrumb_inner">
                    <h2 className="child_breadcrumb_title">
                        Feelings
                    </h2>
                </div>
            </div>
            <div className="article-container">
                {feelings 
                    ? feelings.map((feeling) =>
                        <ResourceCard 
                            key={feeling.resource_id} 
                            icon_id={feeling.icon_id}
                            link={feeling.link}
                            document_id={feeling.document_id}
                            name={feeling.name}
                            description={feeling.description}
                        />
                    ) 
                    : <Loading />
                }
            </div>
        </div>
    );
}

export default Feelings;
